<template>
  <div class="content if-profile">
    <MPHeader v-if="headerData" :headerData="this.headerData" />
    <div class="md-layout ratios-report">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 marketprof-competitors p-0"
      >
        <div class="finanical-report-messages">
          <h1 class="section_header">Startups</h1>
          <!-- <div class="">
            <md-dialog :md-active.sync="showDialog">
              <p>How vigorous is entrepreneurship in your market area? In addition to displaying the market area startup
                population (two years or less), the table calculates average startup sales, which frequently diverge from
                the industry and small business average. Industry startup market share is also displayed.
              </p>
             <p>How does startup activity compare to the US industry benchmark? <br> <br>
               Startup rates are calculated by dividing the number of industry market
               startups by the total number of operations for which an age is known.
               The Local startup index compares market area and national start rates,
               presenting them as a two decimal index where identical rates would be 1.00.
             </p>
            </md-dialog>
            <md-card-header class="md-card-header-icon messages-box">
              <div class="card-icon md-ripple" @click="showDialog = true">
                <md-icon class="icon-arrow">double_arrow </md-icon>
                <md-icon>help</md-icon>
              </div>
            </md-card-header>
          </div>-->
        </div>
        <div class="navbar md-toolbar md-transparent md-elevation-4 finanical-report-messages p-0">
          <nav-tabs-card no-label md-elevation="0">
            <template slot="content">
              <md-tabs md-alignment="left" class="if_card">
                <md-tab md-label="Values" md-icon="window" class="p-0">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 p-0">
                      <md-card class="m-0">
                        <md-card-header> Startup Performance</md-card-header>
                        <md-card-content>
                          <div class="md-layout p-4">
                            <div class="md-layout-item md-size-100 blue-tbl">
                              <md-card class="md-card-profile">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Startup Performance (Firms)</div>
                                  </h4>
                                  <!-- <h4 class="title text-left">Startup Performance (Firms)</h4> -->
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                    >
                                      <md-table
                                        v-if="tableDataStartupPerformance && tableDataStartupPerformance.length"
                                        v-model="tableDataStartupPerformance"
                                        table-header-color="blue"
                                        class="profit-and-loss-table"
                                      >
                                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                                          <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                          <md-table-cell
                                            v-for="key in Object.keys(item.dates)"
                                            :key="key"
                                            :md-label="years[key]"
                                          >{{ item.dates[key] }}</md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <md-card class="md-card-profile">
                                <md-card-content>
                                  <chart-card
                                    header-animation="false"
                                    :chart-data="startupPerformanceLineChart.data"
                                    :chart-options="startupPerformanceLineChart.options"
                                    chart-type="Bar"
                                    header-icon
                                    chart-inside-content
                                    no-footer
                                    background-color="blue"
                                  >
                                    <template slot="chartInsideHeader">
                                      <h4 class="title m-0">
                                        <div
                                          class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                        >Industry Startups (&#60;2 Years)</div>
                                      </h4>
                                      <!-- <h4 class="title">Industry Startups (2 Years)</h4> -->
                                    </template>
                                  </chart-card>
                                   <!-- <div class="pie-line">
                                <ul>
                                <li><span class=""><i class="fa fa-square sky-blue-color"></i></span> Average Operation</li>
                                  <li><span class=""><i class="fa fa-square blue-color"></i></span> Average Small Business</li>

                                </ul>
                              </div> -->
                                </md-card-content>

                              </md-card>
                            </div>

                          </div>
                        </md-card-content>
                      </md-card>
                    </div>
                  </div>
                  <!-- <div class="md-layout">
                    <div class="md-layout-item md-medium-size-100 md-size-50">
                      <chart-card
                        header-animation="false"
                        :chart-data="startupPerformanceLineChart.data"
                        :chart-options="startupPerformanceLineChart.options"
                        chart-type="Line"
                        header-icon
                        chart-inside-content
                        no-footer
                        background-color="blue">
                        <template slot="chartInsideHeader">
                          <div class="card-icon">
                            <md-icon>timeline</md-icon>
                          </div>
                          <h4 class="title">Industry Startups (2 Years)</h4>
                        </template>
                      </chart-card>
                    </div>
                    <div class="md-layout-item md-medium-size-50 md-size-50">
                      <md-card>
                        <md-card-content>
                          <div class="md-card-header md-card-header-icon md-card-header-blue"></div>
                          <h4 class="Performance Scores">
                            Competitive Market Narrative
                          </h4>
                          <p>

                            Startup rates are calculated by dividing the number of industry market startups by the total number of operations
                            for which an age is known. (Due to the limited number of new operations at any given time, this indicator may be
                            less useful in small local market areas.)
                          </p>
                        </md-card-content>
                    </md-card>
                    </div>
                  </div>-->
                </md-tab>
                <md-tab md-label="Index" md-icon="legend_toggle" class="p-0">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 p-0">
                      <md-card class="m-0">
                        <md-card-header>Startup Activity </md-card-header>
                        <md-card-content>
                          <div class="md-layout p-4">
                            <div class="md-layout-item md-size-100 blue-tbl">
                              <md-card class="md-card-profile">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Startup Activity Rates (Firms and Branches)</div>
                                  </h4>
                                  <!-- <h4 class="title text-left">Startup Activity Rates (Firms and Branches)</h4> -->
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                    >
                                      <md-table
                                        v-model="tableDataStartupActivityRates"
                                        table-header-color="blue"
                                        class="profit-and-loss-table"
                                      >
                                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                                          <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                          <md-table-cell
                                            v-for="key in Object.keys(item.dates)"
                                            :key="key"
                                            :md-label="years[key]"
                                          >{{ item.dates[key] }}</md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <md-card class="md-card-profile">
                                <md-card-content>
                                  <chart-card
                                    header-animation="false"
                                    :chart-data="startupActivityRatesLineChart.data"
                                    :chart-options="startupActivityRatesLineChart.options"
                                    chart-type="Line"
                                    header-icon
                                    chart-inside-content
                                    no-footer
                                    background-color="blue"
                                  >
                                    <template slot="chartInsideHeader">
                                      <h4 class="title m-0">
                                        <div
                                          class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                        >Industry Startups (2 Years)</div>
                                      </h4>
                                      <!-- <h4 class="title">Industry Startups (2 Years)</h4> -->
                                    </template>
                                  </chart-card>
                                   <div class="pie-line">
                                <ul>
                                <li><span class=""><i class="fa fa-square yellow-color"></i></span> Local Industry Startup Rate (%)</li>
                                 <li><span class=""><i class="fa fa-square sky-blue-color"></i></span>US Industry Startup Rate (%)</li>
                                 <li><span class=""><i class="fa fa-square red-color"></i></span> Local Industry Startup Index (US=1.00)</li>
                                </ul>
                              </div>
                                </md-card-content>
                              </md-card>
                            </div>
                              <div class="md-layout-item md-medium-size-100 md-size-50">
                              <md-card class="md-card-profile">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      <md-icon class="color-white">article</md-icon> Startups
                                    </div>
                                  </h4>
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div class="md-layout-item md-medium-size-100 md-size-100">
                                      <div class="extra_space">
                                        <!-- <h4 class="Performance Scores">
                                          Competitive Market Narrative
                                        </h4>-->
                                        <p>
                                           In addition to displaying the market area
                                          startup population (two years or less), the table calculates average startup sales, which frequently
                                          diverge from the industry and small business average.
                                          Industry startup market share is also displayed.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>

                          </div>
                        </md-card-content>
                      </md-card>
                    </div>
                  </div>
                  <!-- <div class="md-layout">
                    <div class="md-layout-item md-medium-size-100 md-size-50">
                      <chart-card
                        header-animation="false"
                        :chart-data="startupActivityRatesLineChart.data"
                        :chart-options="startupActivityRatesLineChart.options"
                        chart-type="Line"
                        header-icon
                        chart-inside-content
                        no-footer
                        background-color="blue">
                        <template slot="chartInsideHeader">
                          <div class="card-icon">
                            <md-icon>timeline</md-icon>
                          </div>
                          <h4 class="title">Industry Startups (2 Years)</h4>
                        </template>
                      </chart-card>
                    </div>
                    <div class="md-layout-item md-medium-size-50 md-size-50">
                      <md-card>
                        <md-card-content>
                          <div class="md-card-header md-card-header-icon md-card-header-blue"></div>
                          <h4 class="Performance Scores">
                            Competitive Market Narrative
                          </h4>
                          <p>

                            Startup rates are calculated by dividing the number of industry market startups by the total number of operations
                            for which an age is known. (Due to the limited number of new operations at any given time, this indicator may be
                            less useful in small local market areas.) ​<br> <br>

                          </p>
                        </md-card-content>
                        </md-card>
                    </div>
                  </div>-->
                </md-tab>
              </md-tabs>
            </template>
          </nav-tabs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ChartCard, NavTabsCard } from "@/components";
import { mapState } from 'vuex';
import MPHeader from './MPHeader';

export default {
  components: {
    ChartCard,
    NavTabsCard,
    MPHeader,
  },
  props: ['headerData'],
  data() {
    return {
      showDialog: false,
      tableDataStartupPerformance: [],
      tableDataStartupActivityRates: [],
      startupPerformanceLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          showPoint: true,
          height: "300px",
        },
      },
      startupActivityRatesLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          showPoint: true,
          height: "300px",
        },
      },
      filtered_population: [],
      filtered_market_volume: [],
      filtered_market_share: [],
      filtered_annual_sales: [],
      filtered_penetration: [],
      filtered_employment: [],
      filtered_market_by_class: [],
      filtered_market_percent_by_class: [],
      filtered_average_sale_by_class: [],
      filtered_establishment_by_class: [],
      filtered_total_employment_by_class: [],
      filtered_average_employment_by_class: [],
      filtered_annual_sales_per_employee: [],
      filtered_average_annual_wage: [],
      filtered_rent_per_employee: [],
      filtered_startup_info: [],
      filtered_cessation_info: [],
      filtered_ownership_info: [],
      filtered_demographic_info: [],

    };
  },
  computed: {
    ...mapState({
      startupsValues: state => state.user.industryProfile.data['startupsValues'],
      startupsIndex: state => state.user.industryProfile.data['startupsIndex'],
      years: state => state.user.industryProfile.years,
      release_years: state => state?.user?.industryProfile?.general?.release_years,
      employment: state => state.user.industryProfile.data['employment'],
      release_display: state => state?.user?.industryProfile?.general?.['release_display'],
      tableCompetitors: state => state.user.industryProfile.data['competitors'],
      marketVolume: state => state.user.industryProfile.data['marketVolume'],
      marketShare: state => state.user.industryProfile.data['marketShare'],
      bznaics_code: state => state?.user?.industryProfile?.general?.bznaics,
      sector_name: state => state?.user?.industryProfile?.general?.sector,
      industry_title: state => state?.user?.industryProfile?.general?.industry,
      update_month: state => state.user.industryProfile.updateMonth,
      display_area: state => state?.user?.industryProfile?.general?.area_display_name,
      annualSales: state => state.user.industryProfile.data['annualSales'],
      annualSalesCols: state => state.user.industryProfile['annualSalesCols'],
      penetration: state => state.user.industryProfile.data['penetration'],
      salesEmpSales: state => state.user.industryProfile.data['salesEmpSales'],
      salesEmpCols: state => state.user.industryProfile['salesEmpCols'],
      salesEmpEmployment: state => state.user.industryProfile.data['salesEmpEmployment'],
      productivity: state => state.user.industryProfile.data['productivityValues'],
      startupPerformance: state => state.user.industryProfile.data['startupsValues'],
      startupRates: state => state.user.industryProfile.data['startupsIndex'],
      cessation: state => state.user.industryProfile.data['cessation'],
      ownership: state => state.user.industryProfile.data['ownership'],
      demographics: state => state.user.industryProfile.data['demographics'],
      cmnText: (state) =>state.user.cmnText,
      cessation_years: (state) => state?.user?.industryProfile?.general?.cessation_years,
    }),
    cessationLabel() {
      return this.cessation_years && this.cessation_years.length === 2
        ? `${this.cessation_years[0]}-${this.cessation_years[1]} Cessation Rates`
        : 'Cessation Rates';
    },
    getCsvData() {
      let csvData = [
        [
          'Bizminer Local Industry Market Report',
        ],
        [
          this.bznaics_code, this.industry_title,
        ],
        [
          "Sector: " + this.sector_name,
        ],
        [
          this.display_area,
        ],
        [
          'Data Time Series', this.release_years.toString() + "-" + this.update_month
        ],
        [
          "Update Month", this.update_month,
        ],
        [""],
      ]
      csvData.push(['Industry Population Analyzed'], ['as of:', this.years]);
      this.filtered_population.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '')
        }
        csvData.push(e);
      });
      csvData.push([""], ["Annual Industry Market Volume($)"], ['as of:', this.years]);
      this.filtered_market_volume.forEach((e, i) => {
        e.forEach((k, i) => {
          if (typeof k === 'string' && k.includes('.')) {
            e[i] = k.replace(/\./g, '');
          }
        });
        csvData.push(e);
      });
      csvData.push([""], ["Share(%)"], ['', this.years]);
      this.filtered_market_share.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '')
        }
        csvData.push(e);
      });
      csvData.push([""], [""], ['Average Annual Sales']);
      csvData.push(["", this.annualSalesCols]);
      this.filtered_annual_sales.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.')
        }
        csvData.push(e);
      });
      csvData.push([""], ["Rank"], ['as of:', this.years]);
      csvData.push([""], [""], [""], [""], [""]);
      csvData.push(["Market Penetration ($)"]);
      csvData.push(["", this.years]);
      this.filtered_penetration.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '')
        }
        csvData.push(e);
      });
      csvData.push([""], ["To enhance report load times Sales per Business Establishment values are reported in the IMR-2 file accessible from the My Reports page after you refresh the browser"]);
      csvData.push([""], [""]);
      csvData.push(["Employment", this.years]);
      this.filtered_employment.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '')
        }
        csvData.push(e);
      });
      csvData.push([""], [""]);
      csvData.push(["Market Volume by Employment Class", this.years]);
      this.filtered_market_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.')
        }
        csvData.push(e);
      });
      csvData.push([""], ["Percent Market Volume by Employment Class", this.years]);
      this.filtered_market_percent_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.')
        }
        csvData.push(e);
      });
      csvData.push([""], ["Average Sales by Employment Class", this.years]);
      this.filtered_average_sale_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.')
        }
        csvData.push(e);
      });
      csvData.push([""], ["Establishments by Employment Class", this.years]);
      this.filtered_establishment_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.')
        }
        csvData.push(e);
      });
      csvData.push([""], ["Total Employment by Class", this.years]);
      this.filtered_total_employment_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.')
        }
        csvData.push(e);
      });
      csvData.push([""], ["Average Employment by Class", this.years]);
      this.filtered_average_employment_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.')
        }
        csvData.push(e);
      });
      csvData.push([""], ["Productivity"]);
      csvData.push(["Annual Sales per Employee", this.years]);
      this.filtered_annual_sales_per_employee.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""], [""]);
      csvData.push(["Average Annual Wage", this.years]);
      this.filtered_average_annual_wage.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""], [""]);
      csvData.push(["Rent per Employee", this.years]);
      this.filtered_rent_per_employee.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""], [""]);
      csvData.push(["Productivity Indices (%)", this.years]);
      csvData.push([""], [""], [""], [""], [""]);
      csvData.push(["Startup Activity and Performance"]);
      csvData.push(["", this.years]);
      this.filtered_startup_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""], [""], [""]);
      csvData.push(["To enhance report load times Concentration values are reported in the IMR-2 file accessible from the My Reports page after you refresh the browser"], [""], [""], [""], [""], [this.cessationLabel]);
      this.filtered_cessation_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""], ["Ownership/Consolidation Trends", this.years]);
      this.filtered_ownership_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""], ["Market Area Demographic Highlights"]);
      csvData.push(["(based on zip codes co-joined with your market radius) (2015)"]);
      this.filtered_demographic_info.forEach((element, index) => {
        element.forEach((el, i) => {
          csvData.push(el);
        })
        csvData.push([""]);
      });
      return csvData;
    },

  },
  mounted() {
    let me = this;
    this.tableDataStartupPerformance = Object.entries(this.startupsValues).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
    this.tableDataStartupActivityRates = Object.entries(this.startupsIndex).map(([table, data]) => ({ name: table, dates: Object.values(data) }));

    this.tableDataStartupPerformance.map(item => {
      item.dates = item.dates.map(e => {
        return me.numberWithCommas(e)
      })
      return item
    })
    this.tableDataStartupActivityRates.map(item => {
      item.dates = item.dates.map(e => {
        return me.numberWithCommas(e)
      })
      return item
    })

    this.startupPerformanceLineChart.data = {
      labels: this.years,
      series: [{name: this.tableDataStartupPerformance[0].name, data: this.tableDataStartupPerformance[0].dates}]
    };

    this.startupActivityRatesLineChart.data = {
      labels: this.years,
      series: this.tableDataStartupActivityRates.map(item => ({ name: item.name, data: item.dates }))
    };
    let marketVolume = Object.entries(this.marketVolume).map(([table, data]) => ({
      name: table,
      dates: Object.values(data)
    }));
    marketVolume.map(item => {
      item.dates = item.dates.map(e => {
        return me.numberWithCommas(e)
      })
      return item
    })
    let modifiedArr = [];
    marketVolume.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      })
      r.unshift(element.name);
      modifiedArr.push(r);
    })
    modifiedArr.forEach((el) => {
      let modified = el.map(function (el) {
        if (typeof el === 'string' && el.includes(',')) {
          return el.replace(/,/g, '.');
        }
        return el
      });
      this.filtered_market_volume.push(modified);
    });
    let marketShare = Object.entries(this.marketShare).map(([table, data]) => ({
      name: table,
      dates: Object.values(data)
    }));
    marketShare.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      })
      r.unshift(element.name);
      this.filtered_market_share.push(r);
    })
    this.filtered_market_share = this.filtered_market_share.filter((item, index) => {
      return !item.includes("Your Firm");
    });

    let populationData = Object.entries(this.tableCompetitors).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
    populationData.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      })
      r.unshift(element.name);
      this.filtered_population.push(r);
    })
    let tableAnnual = Object.entries(this.annualSales).map(([table, data]) => ({
      name: table,
      dates: Object.values(data)
    }));
    tableAnnual.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      })
      r.unshift(element.name);
      this.filtered_annual_sales.push(r);
    })
    this.filtered_annual_sales = this.filtered_annual_sales.filter((item, index) => {
      if (!item.includes("Your Firm")) {
        return item;
      }
    });
    let penetrationData = Object.entries(this.penetration).map(([table, data]) => ({
      name: table,
      dates: Object.values(data)
    }));
    penetrationData.map(item => {
      item.dates = item.dates.map(e => {
        return me.numberWithPoints(e)
      })
      return item
    })
    penetrationData.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      })
      r.unshift(element.name);
      this.filtered_penetration.push(r);
    });
    let employmentData = Object.entries(this.employment).map(([table, data]) => ({
      name: table,
      dates: Object.values(data)
    }));
    employmentData.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      })
      r.unshift(element.name);
      this.filtered_employment.push(r);
    });
    this.filtered_employment = this.filtered_employment.filter((item, index) => {
      return !item.includes("Your Firm");
    });

    let marketVolumeByClass = Object.entries(this.salesEmpSales.marketVolume).map(([name, data]) => ({
      name,
      dates: data
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      marketVolumeByClass.forEach((el, num) => {
        b.push(el.dates[index])
      })
      b.unshift(element);
      this.filtered_market_by_class.push(b);
    })
    let marketPercentVolumeByClass = Object.entries(this.salesEmpSales.percentMarket).map(([name, data]) => ({
      name,
      dates: data
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      marketPercentVolumeByClass.forEach((el, num) => {
        b.push(el.dates[index])
      })
      b.unshift(element);
      this.filtered_market_percent_by_class.push(b);
    })
    let averageSaleByClass = Object.entries(this.salesEmpEmployment.average).map(([name, data]) => ({
      name,
      dates: data
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      averageSaleByClass.forEach((el, num) => {
        b.push(el.dates[index])
      })
      b.unshift(element);
      this.filtered_average_sale_by_class.push(b);
    })

    let establishmentByClass = Object.entries(this.salesEmpEmployment.establishments).map(([name, data]) => ({
      name,
      dates: data
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      establishmentByClass.forEach((el, num) => {
        b.push(el.dates[index])
      })
      b.unshift(element);
      this.filtered_establishment_by_class.push(b);
    })
    let totalEmploymentByClass = Object.entries(this.salesEmpEmployment.total).map(([name, data]) => ({
      name,
      dates: data
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      totalEmploymentByClass.forEach((el, num) => {
        b.push(el.dates[index])
      })
      b.unshift(element);
      this.filtered_total_employment_by_class.push(b);
    })

    let averageEmploymentByClass = Object.entries(this.salesEmpEmployment.average).map(([name, data]) => ({
      name,
      dates: data
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      averageEmploymentByClass.forEach((el, num) => {
        b.push(el.dates[index])
      })
      b.unshift(element);
      this.filtered_average_employment_by_class.push(b);
    })
    let annualSalesPerEmployee = Object.entries(this.productivity.spe).map(([name, data]) => ({ name, dates: data }));
    annualSalesPerEmployee.map(item => {
      item.dates = item.dates.map(e => {
        return me.numberWithPoints(e)
      })
      return item
    })
    annualSalesPerEmployee.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      })
      r.unshift(element.name);
      this.filtered_annual_sales_per_employee.push(r);
    });
    this.filtered_annual_sales_per_employee = this.filtered_annual_sales_per_employee.filter((item, index) => {
      return !item.includes("Your Firm");
    });

    let averageAnnualWage = Object.entries(this.productivity.annualWage).map(([name, data]) => ({ name, dates: data }));
    averageAnnualWage.map(item => {
      item.dates = item.dates.map(e => {
        return me.numberWithPoints(e)
      })
      return item
    })
    averageAnnualWage.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      })
      r.unshift(element.name);
      this.filtered_average_annual_wage.push(r);
    });
    this.filtered_average_annual_wage = this.filtered_average_annual_wage.filter((item, index) => {
      return !item.includes("Your Firm");
    });

    let rentPerEmployee = Object.entries(this.productivity.rent).map(([name, data]) => ({ name, dates: data }));
    rentPerEmployee.map(item => {
      item.dates = item.dates.map(e => {
        return me.numberWithPoints(e)
      })
      return item
    })
    rentPerEmployee.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      })
      r.unshift(element.name);
      this.filtered_rent_per_employee.push(r);
    });
    this.filtered_rent_per_employee = this.filtered_rent_per_employee.filter((item, index) => {
      return !item.includes("Your Firm");
    });

    let startupPerformance = Object.entries(this.startupPerformance).map(([table, data]) => ({
      name: table,
      dates: Object.values(data)
    }));
    startupPerformance.map(item => {
      item.dates = item.dates.map(e => {
        return me.numberWithPoints(e)
      })
      return item
    })
    startupPerformance.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      })
      r.unshift(element.name);
      this.filtered_startup_info.push(r);
    });
    let startupRates = Object.entries(this.startupRates).map(([table, data]) => ({
      name: table,
      dates: Object.values(data)
    }));
    startupRates.map(item => {
      item.dates = item.dates.map(e => {
        return me.numberWithPoints(e)
      })
      return item
    })
    startupRates.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      })
      r.unshift(element.name);
      this.filtered_startup_info.push(r);
    });

    let cessationRates = Object.entries(this.cessation).map(([table, data]) => ({
      name: table,
      dates: Object.values(data)
    }));
    cessationRates.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      })
      r.unshift(element.name);
      this.filtered_cessation_info.push(r);
    });
    let ownerShip = Object.entries(this.ownership).map(([table, data]) => ({ name: table, dates: Object.values(data) }));

    ownerShip.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      })
      r.unshift(element.name);
      this.filtered_ownership_info.push(r);
    });


    let demographicInfo = Object.entries(this.demographics).map(([table, data]) => ({ name: table, data: Object.values(data) }));
    demographicInfo.forEach((element, index) => {
      this.filtered_demographic_info[index] = []
      this.filtered_demographic_info[index].push([element.name])
      element.data.forEach((el, i) => {

        Object.keys(el).forEach(key => {
          let a = el[key];
          a = a.map(e => {
            if (typeof e === 'string' && e.includes(',')) {
              return me.numberWithPoints(e)
            } else {
              return e
            }
          })
          if (!a.includes(key)) {
            a.unshift(key)
          }
          this.filtered_demographic_info[index].push(a);
        })
      })
    })





  },
  methods: {
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
        return x;
      }
    },
    numberWithPoints(x) {
      if (typeof x === 'number') {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      } else if(x === null){
        return x;
      }else
      {
        return x.replace(/,/g, '.');
      }
    },
    downloadCSVData() {
      let csv = '';
      this.getCsvData.forEach((row) => {
        csv += row.join(',');
        csv += "\n";
      });
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'Industry Market Profile.csv';
      anchor.click();
    },
  },
};
</script>
<style lang="scss">
.marketprof-competitors {
  .md-toolbar {
    .md-collapse {
      display: block;

      .md-collapse-content {
        p {
          padding-left: 20px;
        }
      }
    }
  }

  .competitors-list {
    .md-collapse-title {
      font-size: 12px;
      font-weight: 300;
      margin-left: 25px;
    }
    .md-icon {
      font-size: 12px;
      font-weight: 300;
      transform: rotate(-90deg);
      left: 0;
      color: rgba(0, 0, 0, 0.54);
    }
  }

  .competitors-map {
    iframe {
      height: 300px !important;
    }
  }
}
</style>
